// @flow

export const PROVIDED: string = "provided";
export const EQUIPMENT: string = "equipment";
